import gql from 'graphql-tag';

export default gql`
  query UserDetails($id: ID!) {
    user(id: $id) {
      id
      name
      email
      website
      biography
      active
      type
      theater {
        id
        name
      }
      images {
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/UserDetails.js